module.exports = __webpack_public_path__ + "img/mobile-profile-logo-black.d59fe13b.svg";